import { render, staticRenderFns } from "./a4.vue?vue&type=template&id=742ff22b&scoped=true"
import script from "./a4.vue?vue&type=script&lang=js"
export * from "./a4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742ff22b",
  null
  
)

export default component.exports